export const TITLE1 = "Merkmale / Vorlage";
export const TITLE2 = "";
export const PLUS = "weiterer Grenzwert";